import Grid2 from '@mui/material/Unstable_Grid2';

import Icon, { IconName } from '@/components/Icon/Icon';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import useViewPortSize from '@/hooks/useViewportSize';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/sunrunTheme.styles';

import useStyles from './FeatureList.styles';

interface TextListProps {
  list: string[];
  isOnDark?: boolean;
}

export default function FeatureListRow({
  list,
  isOnDark = true,
}: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });
  const { isExtraSmall, isSmall } = useViewPortSize();
  const isMobile = isSmall || isExtraSmall;

  const Feature = ({ feature }: { feature: string }) => {
    return (
      <div className={classes.featureContent}>
        <Icon
          aria-label='check-icon'
          name={IconName.CHECK}
          color={isOnDark ? brandColors.white : brandColors.primaryMain}
          backgroundColor={
            isOnDark ? brandColors.white : brandColors.primaryMain
          }
          innerColor={isOnDark ? brandColors.primaryMain : brandColors.white}
        />
        <p className={cx(globalClasses.body2, classes.featureBody)}>
          {feature}
        </p>
      </div>
    );
  };

  return (
    <GridContainer2 fixed gridProps={{ className: classes.featureListRow }}>
      {isMobile ? (
        list &&
        list.map((feature, index) => (
          <Grid2
            xs={6}
            className={classes.featureItem}
            key={`feature-list-row-${index}`}
          >
            <Feature feature={feature} />
          </Grid2>
        ))
      ) : (
        <Grid2 md={12} className={classes.singleFeatureList}>
          {list &&
            list.map((feature, index) => (
              <Feature feature={feature} key={`feature-list-item-${index}`} />
            ))}
        </Grid2>
      )}
    </GridContainer2>
  );
}
